<template>
  <div v-if="isAvailableForShippingFee()">
    <button @click="setAsShippingFee" :disabled ="loading" class="btn btn-sm " :class="isTheShippingFee ? 'btn-primary' : 'btn-outline-primary' ">
      {{ isTheShippingFee ? $t("globals.shipping_fee") : $t("globals.set_shipping_fee") }}
    </button>
  </div>
</template>
<script>
  import axios from "axios";
	import { mapActions, mapMutations } from "vuex";
	export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      
    },
    data() {
      return {
        loading: false
      };
    },
    methods:{
      ...mapMutations(["setShowLoadingModal"]),
			...mapActions("axios_mod", ["simpleMutation"]),
      isAvailableForShippingFee(){
        return this.item.is_a_webshop_item &&!this.item.is_device && (this.item.kpi_type || '').toLowerCase() === 'other';
      },
      setAsShippingFee(){
        const id = this.item.webshop_item.id;
        this.loading = true;
				this.setShowLoadingModal(true);

        let data = {
            query: `
              mutation WebshopItemSetAsShippingFee($id: ID!) {
                res: WebshopItemSetAsShippingFee(id: $id) 
              }
            `,
            variables: {
              id: parseInt(id, 10)
            }
        };
        this.simpleMutation({data, this_ref: this}).then(() => {
          this.$emit('reloadList');
          
				});
        this.loading = false;
        this.setShowLoadingModal(false);

      }
    },
    computed: {
      isTheShippingFee() {
        return this.item.webshop_item.is_shipping_fee;
      }
    }
  }

</script>
